import React from 'react'

const TablaListaDeSeleccionMaestroDeProcedimiento = ({item,passDataMP}) => {
    const info={
        codigoMaestro:item.PRCODI,
        nombreMaestro:item.PrNomb
    }
    const handleOnclick=()=>{
        passDataMP(info)
    }
  return (
    <tr  className="border-b bg-white" >
      <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">
        <button
            onClick={handleOnclick}
          type="button"
          className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
        >
          Seleccionar
        </button>
      </td>
      <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap">
        {item.PRCODI}
      </td>
      <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap text-left">
        {item.PrNomb}
      </td>
      <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap">
        {item.PClCod}
      </td>
      <td className="text-xs text-gray-900 font-medium px-6 py-2 whitespace-pre-wrap">
        {/* {item.PClCod} */}
      </td>
    </tr>
  )
}

export default TablaListaDeSeleccionMaestroDeProcedimiento